export default "__VITE_ASSET__ByNpJgpf__"